import { render, staticRenderFns } from "./ModalLeakageData.vue?vue&type=template&id=2fd9414a&scoped=true"
import script from "./ModalLeakageData.vue?vue&type=script&lang=js"
export * from "./ModalLeakageData.vue?vue&type=script&lang=js"
import style0 from "./ModalLeakageData.vue?vue&type=style&index=0&id=2fd9414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9414a",
  null
  
)

export default component.exports